import { render, staticRenderFns } from "./VideoBody.vue?vue&type=template&id=0614df72&scoped=true&"
import script from "./VideoBody.vue?vue&type=script&lang=js&"
export * from "./VideoBody.vue?vue&type=script&lang=js&"
import style0 from "./VideoBody.vue?vue&type=style&index=0&id=0614df72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614df72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0614df72')) {
      api.createRecord('0614df72', component.options)
    } else {
      api.reload('0614df72', component.options)
    }
    module.hot.accept("./VideoBody.vue?vue&type=template&id=0614df72&scoped=true&", function () {
      api.rerender('0614df72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/Video/VideoBody.vue"
export default component.exports